// Class: lime.app.IModule

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IModule = function() {}

// Meta

IModule.__name__ = "lime.app.IModule";
IModule.__isInterface__ = true;
IModule.prototype = {
	
};
IModule.prototype.__class__ = IModule.prototype.constructor = $hxClasses["lime.app.IModule"] = IModule;

// Init



// Statics




// Export

exports.default = IModule;